export default __webpack_public_path__ + "static/media/ppl-quote-dark.8926ad7d.svg";